module.exports = __webpack_public_path__ + "img/background.70b23f0c.png";